export const Images = {
    logo: require('@assets/images/icon.png'),
    logoW: require('@assets/images/icon_white.png'),
    logoB: require('@assets/images/icon_black.png'),
    saveTemplate: require('@assets/images/save-template.jpg'),
};
